import { render } from "./CreatePromoCode.vue?vue&type=template&id=2b048377&scoped=true"
import script from "./CreatePromoCode.vue?vue&type=script&lang=js"
export * from "./CreatePromoCode.vue?vue&type=script&lang=js"

import "./CreatePromoCode.vue?vue&type=style&index=0&id=2b048377&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b048377"]])

export default __exports__